/** 
 * 
 * Simple Modal Management
 * 
 * @copyright European Parliament (c) 2021
 * @author Edwin Joassart <edwin.joassart@ext.europarl.europa.eu>
 * 
 * (made for Pegasus)
 * 
 * Usage : 
 * modal div should have a unique id
 * control button (or links) must have class ep_modal-control
 * control button (or links) must have a data-modal_target attribute with the id of the modal
 * control button (or links) must have a data-modal_action attribute with either "open" or "close"
 * control button (or links) can have a data-modal_default_action attribute (true) to proceed with default behaviour of the button / link (no preventDefault) -> without it it will preventDefault actions
 * 
 * HTML Example 

<button id="" name="" class="ep_buton btn-black ep_modal-control" data-modal_target="modal-delete-profile" data-modal_action="open" type="submit">
    Open Modal
</button>

<div class="ep_modal-tooltip fx--fade nodisplay" id="modal-delete-profile" role="dialog" labelledby="dialog_label" aria-modal="false" tabindex="0">
  Modal Content
  <button id="" name="" class="ep_buton btn-black ep_modal-control" data-modal_target="modal-delete-profile" data-modal_action="close" type="submit">
    Close Modal
  </button>

  <button id="" name="" class="ep_buton btn-black ep_modal-control" data-modal_target="modal-delete-profile" data-modal_action="close" data-modal_default_action="true" type="submit">
    Delete Account
  </button>

</div>
 * 
 * = 2021 update
 * Replace a div with a modal, using the `open-replace`
 * 
 */

const DEFAULT_SELECTOR = '.ep_modal-control';

class ModalControl {
  /** Add modal control to a button or links */
  constructor(element) {

    // Attach the trigger to a button or a link
    if(element.tagName.toLowerCase() === 'button' || element.tagName.lowerCase === 'a') this.attach(element);

    // Trig immediately if it's a div
    if(element.tagName.toLowerCase() === 'div') this.autoTrig(element);
  }

  /** add event listener on link or button */
  attach(element) {
    element.addEventListener('click', (event_) => {
      if (!event_.currentTarget.dataset.modal_default_action)
        event_.preventDefault();

      // prevent action if the button is disabled
      if (event_.currentTarget.classList.contains('ep_button-disable')) return;

      this.openClose(
        event_.currentTarget.dataset.modal_target,
        event_.currentTarget.dataset.modal_action
      );
    });
  }

  /** 
   * trig the opening at load 
   * used for "open-replace" actions on div
   * 
  */
  autoTrig(element) {
    this.openClose(
      element.dataset.modal_target,
      element.dataset.modal_action,
      element
    )
  }

  /** 
   * open/close the modal 
   * @param {string} targetId - id of the modal node
   * @param {string} action - action to perform [open|open-replace|close]
   * @param {node} original - node that triggered the action (optional)
   * */
  openClose(targetId, action, original) {
    const target = document.querySelector(`#${targetId}`);
    if (!target) return;

    if (action === 'open' || action === 'open-replace') {
      target.classList.remove('nodisplay');
      target.setAttribute('aria-modal', true);
      target.setAttribute('tabindex', '0');

      // if replace, hide the nojs part
      if (action === 'open-replace' && original) {
        original.classList.add('nodisplay');
      }
      return;
    }

    if (action === 'close') {
      target.classList.add('nodisplay');
      target.setAttribute('aria-modal', false);
      target.removeAttribute('tabindex');
    }
  }

  /** Init : find and augment all buttons and links with ep_modal-control class */
  static init(selector) {
    document
      .querySelectorAll(selector || DEFAULT_SELECTOR)
      .forEach((trigger) => new ModalControl(trigger));

    console.info("Modal-control : 2.0");
  }
}

export default ModalControl
